var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128050(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-2,.cls-6{stroke:#65696a;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-5,.cls-6{stroke-width:1.25px;}.cls-3,.cls-4{stroke:#f27230;}.cls-4{stroke-width:6.25px;}.cls-5{stroke:#6e6e6e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.53,100a45.6,45.6,0,1,1,3.25,2.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.21,92.84A34.27,34.27,0,1,0,43,90.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.14,95a39.39,39.39,0,1,1,3.09,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.64,83.18A22.67,22.67,0,1,0,48,79.61c.46.45.92.88,1.41,1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.29,88.21a28.74,28.74,0,1,0-5.54-4.34A27.29,27.29,0,0,0,46.1,86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.28,71.34a11,11,0,1,1,2.7,2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 63.87,
    cy: 63.32,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.81,78.37a16.91,16.91,0,1,0-3.74-2.82c.22.22.44.43.67.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.2,
    y1: 64.1,
    x2: 31.08,
    y2: 112.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "29.87 105.57 35.88 104.92 37.42 110.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "28.3 108 34.3 107.35 35.85 112.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "26.47 110.57 32.47 109.92 34.02 115.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "62.61 70.04 63.57 63.59 63.57 63.59 57.92 67.17 62.61 70.04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128050);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_050.1c464bf8e7b2615abc48ab3efc39acfa.svg";
export { ForwardRef as ReactComponent };